import React from "react"
import SEO from "../components/seo"
import AlgoliaStoriesWeek from "../components/algolia/algolia-stories-week"
import { FormattedMessage } from "react-intl"
import "./404.css"

const NotFoundPage = () => (
  <section>
    {/* <SEO title="404: Not found" />
    <div className="inner inner-404">
      <h1><FormattedMessage
        id="404-page-not-found"
        defaultMessage="Page Not Found"
      /></h1>
      <p><FormattedMessage
        id="404-page-paragraph"
        defaultMessage="Sorry, we can't seem to find the page you're looking for. But we are still determined to help you find your way in life! Stick around to browse stories about careers and people you may not otherwise meet."
      /></p>
      <AlgoliaStoriesWeek />
    </div> */}
  </section>
)

export default NotFoundPage
